// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonFollowLink_root__2XxgX"};